const SELECTED_CURRENCY_STORAGE_KEY = 'selectedCurrency';
const SELECTED_CURRENCY_NONE = '';

export function saveCurrencySelection(currencyCode: string) {
  localStorage.setItem(SELECTED_CURRENCY_STORAGE_KEY, currencyCode);
}

export function noCurrencySelected(currencyCode: string) {
  return currencyCode === SELECTED_CURRENCY_NONE;
}

export function getDefaultCurrency() {
  return 'USD';
}

export function restoreCurrencySelection() {
  if (typeof localStorage === 'undefined') return SELECTED_CURRENCY_NONE;
  const result = localStorage.getItem(SELECTED_CURRENCY_STORAGE_KEY);
  return result === null ? SELECTED_CURRENCY_NONE : result;
}
